// extracted by mini-css-extract-plugin
module.exports = {"header":"WordsListAgs_header__2JWQe","listsWrapper":"WordsListAgs_listsWrapper__2dZMy","wordsList":"WordsListAgs_wordsList__au-qm","wordField":"WordsListAgs_wordField__1NJWu"};